import React, { Component } from 'react';
import MexicoFooter from './mexico';
import GrFooter from './grfooter';
import EnFooter from "./enfooter";
import EgFooter from './egfooter';
import PsFooter from './psfooter';
import JoFooter from './jofooter';
import NoFooter from './nofooter';
import PlFooter from './plfooter';
import FrFooter from './frfooter';
import Iefooter from './iefooter';
import Zafooter from './zafooter';
import Sefooter from './sefooter';
import Rofooter from './rofooter';
import './style.css';


class Footer extends Component {
    render() {
        return (
            <footer className={`${this.props.country == 'za' ? 'footer_za_style':''}`} >
                { (this.props.country === 'es' || this.props.country === 'mx')  && <MexicoFooter /> }
                { this.props.country === 'gr' && <GrFooter/> }
                {this.props.country == 'ps' && <PsFooter />}
                {this.props.country == 'eg' && <EgFooter />}
                {this.props.country == 'en' && <EnFooter />}
                {this.props.country == 'jo' && <JoFooter />}
                {this.props.country == 'no' && <NoFooter />}
                {this.props.country == 'pl' && <PlFooter />}
                {this.props.country == 'fr' && <FrFooter />}
                {this.props.country == 'ie' && <Iefooter />}
                {this.props.country == 'za' && <Zafooter />}
                {this.props.country == 'se' && <Sefooter />}
                {this.props.country == 'ro' && <Rofooter/>}
            </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/mobioastro/components/footer/footer.js